/** Recurrence field state for the task form. */
import { useState } from 'react';

const DEFAULT_INTERVAL = 1;
const DEFAULT_FREQUENCY = 'days';

function readRecurrenceSeed(initialTask) {
  const recurrence = initialTask?.recurrence;
  return {
    enabled: Boolean(recurrence),
    interval: recurrence?.interval ?? DEFAULT_INTERVAL,
    frequency: recurrence?.frequency ?? DEFAULT_FREQUENCY,
  };
}

export function useTaskFormRecurrence(initialTask) {
  const seed = readRecurrenceSeed(initialTask);
  const [isRecurrenceEnabled, setIsRecurrenceEnabled] = useState(seed.enabled);
  const [recurrenceInterval, setRecurrenceInterval] = useState(seed.interval);
  const [recurrenceFrequency, setRecurrenceFrequency] = useState(
    seed.frequency,
  );

  return {
    isRecurrenceEnabled,
    setIsRecurrenceEnabled,
    recurrenceInterval,
    setRecurrenceInterval,
    recurrenceFrequency,
    setRecurrenceFrequency,
    recurrence: isRecurrenceEnabled
      ? { interval: recurrenceInterval, frequency: recurrenceFrequency }
      : null,
  };
}
